var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Popup',{attrs:{"visible":_vm.localVisible},on:{"update:visible":function($event){_vm.localVisible=$event},"closePopup":function($event){return _vm.$emit('closePopup')}}},[_c('PaymentMethod',{staticClass:"payment-method-popup",on:{"closePopup":function($event){return _vm.$emit('closePopup')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }